class AlgoliaDrawer extends HTMLElement {
  static get observedAttributes() {
    return ['src'];
  }

  get SRC() {
    return this.getAttribute('src');
  }

  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#AlgoliaDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelectorAll(".algolia-icon-bubble");
    cartLink.forEach((item) => {
      item.setAttribute("role", "button");
      item.setAttribute("aria-haspopup", "dialog");
      item.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(item);
      });
      item.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(item);
        }
      });
    });
  }

  open(triggeredBy) {
    this.callClient();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      document.querySelector("body").style.overflow = "hidden";
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("AlgoliaDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.querySelector("body").style.overflow = "auto";
  }

  callClient(){
    const searchContainer = document.getElementById('algolia_instant_search');
    const scriptElement = document.createElement('script');
    scriptElement.src = this.SRC;
    scriptElement.defer = true;
    scriptElement.type = 'module';
  
    searchContainer.appendChild(scriptElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "algolia-drawer",
        selector: "#AlgoliaDrawer",
      },
      {
        id: "algolia-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("algolia-drawer", AlgoliaDrawer);

class AlgoliaDrawerItems extends AlgoliaItems {
  getSectionsToRender() {
    return [
      {
        id: "AlgoliaDrawer",
        section: "algolia-drawer",
        selector: ".drawer__inner",
      },

      {
        id: "algolia-icon-bubble",
        section: "algolia-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("algolia-drawer-items", AlgoliaDrawerItems);
